export default {
    token: null,
    customer: null,
    cart : {
        items: [],
        bankPaymentTypeId:0,
        totalPrice:0,
        unitTotalPrice: 0,
        dt: Date.now()
    },
    selectedShop: null,
    selectedProduct:null
};
